module.exports = __webpack_public_path__ + "static/linkedinlogo-8655549ad436377a43ac13fb1f6b795d.png";